import Index from "@frog/source/models/App.js"
import Director from "@frog/source/models/juice/Director.js"
import Keyset from "@frog/source/utility/Keyset.js"

import pixel from "@frog/source/views/app/stage/pixel.js"

import protounits from "@frog/source/data/units.js"

// TODO: replace this with a formal centralized image static reference.
const unitImages = {
    "family:box/level:1": require("@frog/source/images/half-block-boz.png"),
    // "family:ranger/level:1": require("@frog/source/images/tamer.png")
}

export default function Units(stage) {
    return Object.values(stage.units).map((unit) => {
        if(unit.isDead == true) {
            return // DO NOT RENDER AT ALL?? NOT EVEN FOR TRANSITION?
        }
        // if(unit.affiliation == "good") return
        let omegaunit = undefined
        // // Rendering the unit position for where they will be after the hoveredAction (push/pull included)
        // if(Director.isPerforming != true
        // && Index.game.encounter != undefined
        // && Index.game.encounter.selection != undefined
        // && Index.game.encounter.selection.hoveredAction != undefined
        // && Index.game.encounter.selection.hoveredAction.omegastage != undefined) {
        // // && Index.game.encounter.selection.hoveredAction.performerKey == unit.key) { // this last conditional restricts it ot just the performer
        //     omegaunit = Index.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
        // }
        let unitForPosition = omegaunit || unit
        let position = {
            "x": unitForPosition.position.x,
            "y": unitForPosition.position.y,
            "z": unitForPosition.position.z,
        }
        // // Rendering the unit position as hovered action only.
        // if(Director.isPerforming != true
        // && Index.game.encounter != undefined
        // && Index.game.encounter.selection != undefined
        // && Index.game.encounter.selection.hoveredAction != undefined
        // && Index.game.encounter.selection.hoveredAction.performerKey  == unit.key) {
        //     position = Index.game.encounter.selection.hoveredAction.position
        // }
        if(unit.transform != undefined
        && unit.transform.position != undefined) {
            position.x += unit.transform.position.x || 0
            position.y += unit.transform.position.y || 0
            position.z += unit.transform.position.z || 0
        }
        let image = unit.image
        if(unitImages[unit.reference] != undefined) {
            image = unitImages[unit.reference]
        }
        const protounit = protounits[unit.reference]
        if(protounit != undefined) {
            image = image || protounit.image
        }
        const unitsprite = {
            "key": "unit/" + unit.key + "/sprite",
            // "type": unit.family != "ranger" && unit.family != "baddie" && unit.reference != "box" ? "unit" : undefined, // used for anchor??
            "position": pixel("unit", {
                "x": position.x,
                "y": position.y,
                "z": position.z // + 0.001
            }),
            "image": image,
            // "scale": unit.family != "ranger" && unit.family != "baddie"  && unit.reference != "box" ? {"x": 5, "y": 5} : undefined,
        }

        let unitForHealth = omegaunit || unit
        // if(Director.isPerforming != true
        // && Index.game.encounter != undefined
        // && Index.game.encounter.selection != undefined
        // && Index.game.encounter.selection.activeUnit != undefined
        // && Index.game.encounter.selection.activeUnit.affiliation == "bad"
        // && stage.nextTurn != undefined
        // && stage.nextTurn.omegastage != undefined
        // && stage.nextTurn.omegastage.units[unit.key] != undefined) {
        //     unitForHealth = stage.nextTurn.omegastage.units[unit.key]
        //     // TODO: This is showing the entire enemy turn omegastage
        //     // instead of just what damage will be performed by this
        //     // hovered enemy unit. Can we get that granular?
        // }
        // THIS RENDERS THE NEXT TURN'S HEALTH OUTCOME, BUT
        // CURRENTLY RENDERS IT LIKE IT IS THE ACTUAL HEALTH
        let unitForEndangeredHealth = undefined
        // if(Director.isPerforming != true
        // && stage.nextTurn != undefined
        // && stage.nextTurn.omegastage != undefined
        // && stage.nextTurn.omegastage.units[unit.key] != undefined) {
        //     unitForEndangeredHealth = stage.nextTurn.omegastage.units[unit.key]
        // }
        // if(Director.isPerforming != true
        // && Index.game.encounter != undefined
        // && Index.game.encounter.selection != undefined
        // && Index.game.encounter.selection.hoveredAction != undefined
        // && Index.game.encounter.selection.hoveredAction.omegastage != undefined
        // && Index.game.encounter.selection.hoveredAction.omegastage.nextTurn != undefined
        // && Index.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage != undefined
        // && Index.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units != undefined
        // && Index.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units[unit.key] != undefined) {
        //     unitForEndangeredHealth = Index.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units[unit.key]
        // }
        if(Director.isPerforming != true
        && Index.game.encounter != undefined
        && Index.game.encounter.selection != undefined
        && Index.game.encounter.selection.hoveredAction != undefined
        && Index.game.encounter.selection.hoveredAction.omegastage != undefined
        && Index.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined) {
            unitForEndangeredHealth = Index.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
        }
        let health = unitForHealth.health
        if(unitForHealth.transform != undefined
        && unitForHealth.transform.health != undefined) {
            health += unitForHealth.transform.health
        }
        let healthbarsprite = HealthBar(unit.key, health, unitForHealth.maxhealth, position, unitForHealth.affiliation, unitForEndangeredHealth)
        if(unit.affiliation != "good") {
            healthbarsprite = undefined
        }
        // unitsprite.outline = {"thickness": 5, "color": 0xEDE4BE}
        // const trapSprites = TrapSprites(omegaunit || unit)
        if(unit.energy["move"] == false
        && unit.energy["invoke skill"] == false) {
            if(unit.affiliation == "good") {
                unitsprite.grayscale = 1
            }
        } else {
            if(Director.isPerforming != true) {
                if(Index.game.encounter.selection.hoveredUnitKey != undefined
                && Index.game.encounter.selection.hoveredUnitKey == unit.key) {
                    unitsprite.outline = {"thickness": 10, "color": 0xEDE4BE}
                } else if(Index.game.encounter.selection.selectedUnitKey != undefined
                && Index.game.encounter.selection.selectedUnitKey == unit.key) {
                    unitsprite.outline = {"thickness": 10, "color": 0xEDE4BE}
                }
            }
        }
        // if(unit.transform != undefined
        // && unit.transform.grayscale != undefined) {
        //     unitsprite.grayscale = unit.transform.grayscale
        // }
        // if(unit.transform != undefined
        // && unit.transform.rotate != undefined) {
        //     unitsprite.rotation = unit.transform.rotate
        // }
        if(unit.rotation != undefined) {
            unitsprite.rotation = unit.rotation
        }
        if(unit.opacity != undefined) {
            unitsprite.opacity = unit.opacity
            healthbarsprite = undefined // yeah just nuke the whole health bar
        }
        // if(unit.transform != undefined
        // && unit.transform.icon != undefined) {
        //     const iconsprite = {
                    // NEEDS KEY OR WON'T RENDER
        //         "image": unit.transform.icon.image,
        //         "position": pixel("healthbar", {
        //             "x": position.x,
        //             "y": position.y,
        //             "z": position.z + 0.5
        //         }),
        //     }
        //     sprites.push(iconsprite)
        // }
        //
        // This is for shaking a bomb that
        // is about to go off.
        if(unit.reference == "voltorb"
        && unit.effects["fuse"] != undefined
        && unit.effects["fuse"].timer <= 1) {
            unitsprite.position.x += Math.random() * 10 - 5
            unitsprite.position.y += Math.random() * 10 - 5
        }
        let elementsprite = undefined
        if(Director.isPerforming != true
        && (Index.game.encounter.selection.selectedUnitKey == unit.key
        || Index.game.encounter.selection.hoveredUnitKey == unit.key)) {
            const element = elements[unit.element]
            let isInDanger = false
            if(Index.game.encounter.selection.hoveredUnitKey == unit.key
            && Index.game.encounter.selection.selectedUnitKey != undefined
            && Index.game.encounter.selection.selectedUnit.isDead != true
            && Index.game.encounter.selection.hoveredUnit.isDead != true
            && Index.game.encounter.selection.selectedUnitKey != Index.game.encounter.selection.hoveredUnitKey
            && Index.game.encounter.selection.selectedUnit.affiliation != Index.game.encounter.selection.hoveredUnit.affiliation
            && element != undefined
            && element.weaknesses.includes(Index.game.encounter.selection.selectedUnit.element)) {
                isInDanger = true
            }
            if(Index.game.encounter.selection.selectedUnitKey == unit.key
            && Index.game.encounter.selection.hoveredUnitKey != undefined
            && Index.game.encounter.selection.selectedUnit.isDead != true
            && Index.game.encounter.selection.hoveredUnit.isDead != true
            && Index.game.encounter.selection.selectedUnitKey != Index.game.encounter.selection.hoveredUnitKey
            && Index.game.encounter.selection.selectedUnit.affiliation != Index.game.encounter.selection.hoveredUnit.affiliation
            && element != undefined
            && element.weaknesses.includes(Index.game.encounter.selection.hoveredUnit.element)) {
                isInDanger = true
            }
            if(element != undefined
            && element.icon != undefined) {
                elementsprite = {
                    "key": "unit/" + unit.key + "/element",
                    "image": element.icon,
                    "position": pixel("elemental-icon", {
                        "x": position.x + (isInDanger ? Math.random() * 0.1 : 0),
                        "y": position.y + (isInDanger ? Math.random() * 0.1 : 0),
                        "z": position.z + 0.6,
                    }),
                    // "scale": {"x": 1, "y": 0.5},
                }
            }
        }
        const sprites = [
            unitsprite,
            healthbarsprite,
            // trapSprites,
            // elementsprite,
        ]
        return sprites
    })
}

import elements from "@frog/source/data/elements.js"

function HealthBar(unitKey, health, maxhealth, position, affiliation, endangeredUnit) {
    let endangeredHealth = undefined
    if(endangeredUnit != undefined) endangeredHealth = endangeredUnit.health
    const sprites = []
    position = pixel("healthbar", {
        "x": position.x - 0,
        "y": position.y - 0,
        "z": position.z,
    })
    for(let i = 0; i < maxhealth; i += 1) {
        let image = require("@frog/source/images/ld47/hpBar.png")
        if(i < maxhealth - health) {
            image = require("@frog/source/images/ld47/hpBar_empty.png")
        }
        // let isInDanger = false
        // if(endangeredHealth != undefined) {
        //     if(i < endangeredHealth) {
        //         image = require("@frog/source/images/healthbar-tick.png")
        //     } else if(i < health) {
        //         image = require("@frog/source/images/healthbar-tick-danger.png")
        //         isInDanger = true
        //     }
        // }
        sprites.push({
            "key": "unit/" + unitKey + "/health/" + i,
            "image": image,
            "position": {
                // "x": position.x - (i * (38/2)) - ((maxhealth % 2 == 0 ? maxhealth * (38/2) : maxhealth * (38/2) - (38/2)) / 2),
                // "y": position.y - 40 + (isInDanger ? Math.floor(Math.random() * 10) : 0),
                "x": position.x - (i * (window.__.x || 24)), // - ((maxhealth % 2 == 0 ? maxhealth * (38/2) : maxhealth * (38/2) - (38/2)) / 2),
                "y": position.y - (i * (window.__.y || 14)),
                "stack": position.stack,
            },
            // "scale": {"x": 1, "y": 0.5},
            // "rotation": i % 2 == 1 ? 180 : 0
        })
    }
    return sprites
}

window.__ = {}

function TrapSprites(unit) {
    const sprites = []
    if(unit.effects != undefined) {
        Keyset.forEach(unit.effects, (effect, effectKey) => {
            if((effect.type == "trap" || effect.type == "traplike")
            && effect.positions != undefined) {
                effect.positions.forEach((position, index) => {
                    sprites.push({
                        "key": "unit/traps/" + effectKey + "/" + index,
                        // "image": require("@frog/source/images/redyellow.range.png"),
                        "position": pixel("dangerzone", position),
                    })
                })
            }
        })
    }
    return sprites
}
